import { DELETE_COLOR_REQUESTED } from './../edit/edit.actions';
import { FETCH_COLORS_REQUESTED, SORT_COLORS_REQUESTED } from './list.actions';
import { Component, OnInit, OnDestroy } from '@angular/core';
import store from './../../../store/store.module';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnDestroy {
  navigationSubscription: any;
  protected router: any;
  public store = store;

  public orders = {
    id: null,
    name: null,
    sort_order: null
  };

  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, router: Router) {
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({
          type: FETCH_COLORS_REQUESTED, data: {
            ...this.getQuery()
          }
        });
      }
    });
  }


  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  sortBy(field) {
    for (let prop in this.orders) {
      if (prop === field) {
        if (this.orders[field] === null) {
          this.orders[field] = '-';
        } else {
          if (this.orders[field] === '-') {
            this.orders[field] = '';
          } else if (this.orders[field] === '') {
            this.orders[field] = null;
          }
        }
      }
    }
    this.router.navigate(['color'], {queryParams: this.getCurrentQueryString()});
  }

  private getQuery(): object {
    if (!_.isUndefined(this.activeRouter.snapshot.queryParams.orders)) {
      let orders = this.activeRouter.snapshot.queryParams.orders;
      if (orders) {
        this.orders = JSON.parse(orders);
      }
    }
    let queryParams = { page: 1 };
    if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
    }
    let search = '';
    if (this.activeRouter.snapshot.queryParams.search) {
      search = this.activeRouter.snapshot.queryParams.search;
    }
    return {
      sort: this.orders,
      pagination: queryParams,
      search: search
    };
  }

  public getCurrentQueryString() {
    let params = {
      orders: JSON.stringify(this.orders)
    };
    if (this.activeRouter.snapshot.queryParams.search) {
      params['search'] = this.activeRouter.snapshot.queryParams.search;
    }
    let queryParams = { page: 1, per_page: 20 };
    if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
      params['page'] = queryParams.page;
      params['per_page'] = queryParams.per_page;
    }
    return params;
  }
}
